<template>
  <div class="form-container">
    <font-awesome-icon icon="fa-solid fa-arrow-right" class="form-close" @click="pageHome" />

    <img src="https://gthpdf.fra1.digitaloceanspaces.com/logogth.8f1f3863.png" alt="logo" />

    <h2>Authentification</h2>

    <div class="message_client">
      <span>
        Bienvenue dans votre espace sécurisé GTHCONSULT ONLINE.<br>
        Pour accéder à votre compte, merci de vous identifier.
      </span>
    </div>

    <div class="input-box">
      <input type="text" v-model="email" placeholder="Saisissez votre Email" required />
      <font-awesome-icon icon="fa-solid fa-envelope" class="icon-left" />
    </div>

    <div class="input-box">
      <input :type="typeInput" v-model="password" placeholder="Saisissez votre mot de passe" required />
      <font-awesome-icon icon="fa-solid fa-key" class="icon-left" />
      <font-awesome-icon v-if="flagInputPassword" icon="fa-solid fa-eye" class="icon-right" @click="notShowPassword" />
      <font-awesome-icon v-if="!flagInputPassword" icon="fa-solid fa-eye-slash" class="icon-right" @click="showPassword" />
    </div>

    <div class="option_field">
      <input type="checkbox" id="souvenir" @click="handelSouvenir" />
      <label for="souvenir">Se souvenir de moi</label>
    </div>

    <div class="option_field">
      <input type="checkbox" :checked="accepterPolitique" id="politique" @click="handelAccepterPolitique" />
      <label for="politique">
        Vous acceptez notre
        <a href="https://gthconsult.com/politique-de-confidentialite" target="_blank">politique</a>
      </label>
    </div>

    <button @click="login">Connexion</button>

    <div class="message_client">
      <span>
        Pour obtenir l'accès à notre plateforme ou en cas de mot de passe oublié, contactez-nous : <b>contact@gthconsult.ma</b>
      </span>
    </div>

    <ErrorModel :text="textErrorModel" v-if="flagErrorModel" :titre="titreErrorModel" @closeErrorModel="closeErrorModel" @validerErrorModel="validerErrorModel" />
    <loading v-model:active="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage" />
  </div>
</template>

<script>
import Interlocuteur from "@/connection/Interlocuteur";
import { useCookies } from "vue3-cookies";
import ErrorModel from "@/components/models/ErrorModel.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  name: "LoginEspaceClient",
  components: { ErrorModel, Loading },
  data() {
    return {
      titreErrorModel: null,
      textErrorModel: null,
      flagErrorModel: false,
      email: null,
      password: null,
      accepterPolitique: false,
      typeInput: "password",
      flagInputPassword: true,
      isLoading: false
    };
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  methods: {
    closeErrorModel() {
      this.flagErrorModel = false;
    },
    validerErrorModel() {
      this.flagErrorModel = false;
      this.accepterPolitique = !this.accepterPolitique;
    },
    showPassword() {
      this.flagInputPassword = true;
      this.typeInput = "text";
    },
    notShowPassword() {
      this.flagInputPassword = false;
      this.typeInput = "password";
    },
    pageHome() {
      this.$router.push("/");
    },
    handelSouvenir() {
      if (this.cookies.get("email")) {
        this.cookies.remove("email");
        this.cookies.remove("password");
      } else {
        this.cookies.set("email", this.email);
        this.cookies.set("password", this.password);
      }
    },
    handelAccepterPolitique() {
      this.accepterPolitique = !this.accepterPolitique;
    },
    login() {
      if (!this.accepterPolitique) {
        this.titreErrorModel = "POLITIQUE DE CONFIDENTIALITÉ DE GTHCONSULT";
        this.textErrorModel =
          "Lorsque vous utilisez nos services, vous nous confiez vos données professionnelles. Nous comprenons que c'est une grande responsabilité et nous faisons tout notre possible pour protéger vos renseignements et vous permettre de les gérer.";
        this.flagErrorModel = true;
      } else {
        this.isLoading = true;
        Interlocuteur.login(this.email, this.password)
          .then((result) => {
            if (result.data.accessToken) {
              if (result.data.flag) {
                this.cookies.set("accessToken", result.data.accessToken, "1h");
                this.cookies.set("refreshToken", result.data.refreshToken, "1d");
                this.isLoading = false;
                this.$router.push("/transfer-dashboard");
              }
            } else {
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      }
    }
  },
  mounted() {
    this.email = this.cookies.get("email");
    this.password = this.cookies.get("password");
  }
};
</script>

<style scoped>
* {
  font-family: Cairo, Verdana, Tahoma, Arial, sans-serif;
}

.form-container {
  background: #fff;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  max-width: 450px;
  width: 100%;
  text-align: center;
  position: relative;
}

.form-close {
  position: absolute;
  top: 15px;
  right: 20px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
}
.form-close:hover {
  opacity: 1;
}

img {
  width: 50%;
  margin-bottom: 20px;
}

h2 {
  color: #4a148c;
  font-size: 24px;
  margin-bottom: 20px;
}

.message_client span {
  font-size: 13px;
  color: #555;
  display: block;
  margin: 15px 0;
}

.input-box {
  position: relative;
  margin: 20px 0;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px 35px 10px 35px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;
}
input:focus {
  border-color: #4a148c;
}

.icon-left {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #4a148c;
}

.icon-right {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #4a148c;
}

.option_field {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
  font-size: 13px;
}
.option_field a {
  color: #4a148c;
  text-decoration: underline;
}

button {
  background-color: #4a148c;
  color: #fff;
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 8px;
  margin-top: 20px;
  cursor: pointer;
  transition: background-color 0.3s;
}
button:hover {
  background-color: #310d5b;
}
</style>
